import React from 'react';
import cn from 'classnames';
import { capitalizeFirstLetter } from 'utils/helpers';
import GithubIcon from 'design/Icons/GithubIcon';
import GoogleColorIcon from 'design/Icons/GoogleColorIcon';
import SpinnerIcon from 'design/Icons/SpinnerIcon';

import styles from './styles.module.scss';
import MicrosoftIcon from 'design/Icons/MicrosoftIcon';
import { OauthProvider } from 'models/Oauth';

interface OauthButtonProps {
  provider: OauthProvider;
  oauthPending: string;
  oauthLogin: (provider: OauthProvider) => void;
}

const OauthButton = ({ provider, oauthPending, oauthLogin }: OauthButtonProps) => {
  const getIcon = (provider: OauthProvider) => {
    if (provider === 'github') return <GithubIcon width={20} height={20} />;
    if (provider === 'microsoft') return <MicrosoftIcon width={20} height={20} />;
    if (provider === 'google') return <GoogleColorIcon width={20} height={20} />;
    return null;
  };

  return (
    <button
      type="button"
      className={cn('btn', styles.oauthBtn)}
      onClick={() => oauthLogin(provider)}
      disabled={!!oauthPending}
    >
      {oauthPending === provider && <SpinnerIcon className={styles.spinner} />}
      {getIcon(provider)} Log in with {capitalizeFirstLetter(provider)}
    </button>
  );
};

export default OauthButton;
